// @flow
import React, { PureComponent } from 'react'
import StatisticsCells from './StatisticsCells'
import { calculateTotalStatistics } from '../../services/statistics/utils'
import { connect } from 'react-redux'
import _ from 'lodash'
import { translateFunc, translations } from '../../shared/localize'
import { Cell, FooterRow } from '../MainTable'
import type { AdvertisementStatistics } from '../AdvertisementsTable'

const t = translateFunc(translations.advertisement_table_tfoot)

type Props = {|
  adStatistics: { [number]: Array<AdvertisementStatistics> },
  providersList: Array<string>,
  statisticsType: string
|}

class Tfoot extends PureComponent<Props> {
  render() {
    const { adStatistics, providersList, statisticsType } = this.props

    const statistics = calculateTotalStatistics(
      _.values(adStatistics),
      statisticsType,
      providersList
    )

    return (
      <tfoot>
        <FooterRow>
          <Cell alignRight colSpan={4}>
            {t('total')}
          </Cell>
          <StatisticsCells statistics={statistics} />
          <td />
        </FooterRow>
      </tfoot>
    )
  }
}

function mapStateToProps(state) {
  const { providersList, statisticsType } = state.advertisementTable

  return { providersList, statisticsType }
}

export default connect<Object, Props, _, _, _, _>(mapStateToProps)(Tfoot)
